import React from "react";
import { Link } from "react-router-dom";
import m05 from "../../images/icon/feaicons/fea-small-icon03 1.svg";

const FinalCenteredCTA: React.FC = () => {
  return (
    <>
      {/* ================= FINAL CENTERED CTA ================= */}
      <section className="pt-80 pb-80">
        <div className="container d-flex justify-content-center">
          <div
            className="cta-wrapper wow fadeInUp"
            data-wow-delay="100ms"
            style={{
              maxWidth: "850px",
              width: "100%",
              textAlign: "center",
              position: "relative",
            }}
          >
            {/* CTA BOX */}
            <div
              className="service_link"
              style={{
                padding: "40px",
                borderRadius: "18px",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.12)",
                backdropFilter: "blur(10px)",
              }}
            >
              <div className="xb-item--inner">
                {/* ICON + TITLE */}
                <div className="xb-item--holder ul_li d-flex justify-content-center align-items-center">
                  <span
                    className="xb-item--icon"
                    style={{ marginRight: "15px" }}
                  >
                    <img src={m05} alt="icon" style={{ width: 55 }} />
                  </span>

                  <h3 className="xb-item--title" style={{ margin: 0 }}>
                    <Link to="/contact">
                      Need expert blockchain services?
                    </Link>
                  </h3>
                </div>

                {/* SUBTEXT */}
                <p className="xb-item--text mt-20">
                  We provide full-stack blockchain solutions.
                </p>
              </div>

              {/* CTA BUTTON WITH BOTH SVG ARROWS */}
              <Link
                to="/contact"
                className="xb-item--btn mt-30 d-inline-flex align-items-center justify-content-center"
                style={{
                  padding: "12px 24px",
                  borderRadius: "12px",
                  background:
                    "linear-gradient(135deg, #e7721fff, #e56e0dff)",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: 600,
                  gap: "10px",
                }}
              >
                {/* First SVG */}
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="6.29297"
                    y="21.4106"
                    width="22.36"
                    height="2.83936"
                    transform="rotate(-40.2798 6.29297 21.4106)"
                    fill="white"
                  />
                  <rect
                    x="9.44922"
                    y="7.56982"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 9.44922 7.56982)"
                    fill="white"
                  />
                  <rect
                    x="13.4492"
                    y="7.89941"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 13.4492 7.89941)"
                    fill="white"
                  />
                  <rect
                    x="17.4492"
                    y="8.23047"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 17.4492 8.23047)"
                    fill="white"
                  />
                  <rect
                    x="21.1211"
                    y="12.562"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 21.1211 12.562)"
                    fill="white"
                  />
                  <rect
                    x="20.7969"
                    y="16.5645"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 20.7969 16.5645)"
                    fill="white"
                  />
                  <rect
                    x="20.4648"
                    y="20.5664"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 20.4648 20.5664)"
                    fill="white"
                  />
                </svg>

                {/* Second SVG */}
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="6.29297"
                    y="21.4106"
                    width="22.36"
                    height="2.83936"
                    transform="rotate(-40.2798 6.29297 21.4106)"
                    fill="white"
                  />
                  <rect
                    x="9.44922"
                    y="7.56982"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 9.44922 7.56982)"
                    fill="white"
                  />
                  <rect
                    x="13.4492"
                    y="7.89941"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 13.4492 7.89941)"
                    fill="white"
                  />
                  <rect
                    x="17.4492"
                    y="8.23047"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 17.4492 8.23047)"
                    fill="white"
                  />
                  <rect
                    x="21.1211"
                    y="12.562"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 21.1211 12.562)"
                    fill="white"
                  />
                  <rect
                    x="20.7969"
                    y="16.5645"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 20.7969 16.5645)"
                    fill="white"
                  />
                  <rect
                    x="20.4648"
                    y="20.5664"
                    width="2.83936"
                    height="2.83936"
                    transform="rotate(-40.2798 20.4648 20.5664)"
                    fill="white"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinalCenteredCTA;
